import { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { createTenantTheme } from './createTenantTheme';
import { sothebysTokens } from '../tokens/tenants/sothebys';
import { wallaceTokens } from '../tokens/tenants/wallace';
import { GlobalStyles } from './GlobalStyles';
import { TenantTokens } from '../tokens/types';

// Map tenant slugs to their token configurations
const tenantTokensMap: Record<string, TenantTokens> = {
  sothebys: sothebysTokens,
  wallace: wallaceTokens,
};

interface TenantThemeProviderProps {
  children: React.ReactNode;
  tenantSlug?: string;
}

export function TenantThemeProvider({ children, tenantSlug }: TenantThemeProviderProps) {
  const theme = useMemo(() => {
    const tokens = tenantSlug
      ? tenantTokensMap[tenantSlug] || wallaceTokens
      : wallaceTokens;
    return createTenantTheme(tokens);
  }, [tenantSlug]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      {children}
    </ThemeProvider>
  );
}
